import {Component, HostBinding, OnInit} from '@angular/core';
import {ProjectService} from '@catcore/services';

const componentBaseName = 'type-switch';
const selectorName = `cat-${componentBaseName}`;
const defaultClassNames = [selectorName];

@Component({
  templateUrl: './type-switch.component.html',
  styleUrls: ['./type-switch.component.scss'],
})
export class TypeSwitchComponent implements OnInit {
  @HostBinding('class') classNames = [...defaultClassNames, this.classNames].join(' ');

  projectTypes = [
    {
      displayName: 'Global 7000',
      description: 'Start here to create a "Global 7000" project',
      iconName: 'icon-settings',
      route: ['global'],
    }, {
      displayName: 'VIP',
      description: 'Start here to create a default "VIP" project',
      iconName: 'icon-settings',
      route: ['vip'],
    },
  ];

  constructor(private projectService: ProjectService) {
  }

  ngOnInit() {
    this.projectService.resetCurrentProject();
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project/components/type-switch/type-switch.component.ts